import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Routes, Route, Link, useLocation, useParams } from "react-router-dom";
import Loader from "../Loader"

import '../../css/snsearch.css';
import local from './local/sn_srch_localisation';
import API from '../API/api';

export default function SerialSearch(){
    
    const setup = useSelector(state => state.site.setup);
    const [AllIs, setAllIs] = useState({loading:false, error:null});
    const [result,setResult] = useState('');
    const [query,setQuery] = useState('');

    useEffect(() => {
        if(query !== '' && query.length > 2) {GetSearch(query)
        } else {
          setResult('');
        }
      }, [query]);

      if(AllIs.loading){ return <Loader/> } 
    
        // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
        let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';
        
        let langStr = {
        ru:'ru-RU',
        en:'en-GB',
        de:'de-DE'
        }

return(
    <Fragment>
        <div className='snsearch'>
        <h2 className='tae whte'>{local[LANG].form_ttl}</h2>
        <input placeholder='12345678' type="text" className="filter" onChange={handleSearch} autoCorrect="off" autoComplete="off"/>
        <br/>
        {query !== ''? <ShowSearchResult result={result}/> : null}
        </div>
    </Fragment>
)

    function ShowSearchResult(props){

        const result = props.result;
        
            return(
            <Fragment>
                {
                query.length > 2? <p>{local[LANG].msg} {query}</p> : null
                }                    
                <table>
                {
                    result.itm? <thead><th>{local[LANG].dev_ttl}</th><th>{local[LANG].sn}</th><th>{local[LANG].reg}</th><th>{local[LANG].to}</th></thead> : null
                }
                {
                    result.itm? !result.itm.id? 
                    result.itm.map((i, key) => 
                    <tr key={key}>
                        <td>{i.pfx+' '+i.ttl}</td><td>{i.sn}</td><td>{GetDate(i.d)}</td><td>{GetDate(i.exp)}</td>
                    </tr>
                    )
                    : 
                    <tr>
                        <td>{result.itm.pfx+' '+result.itm.ttl}</td><td>{result.itm.sn}</td><td>{GetDate(result.itm.d)}</td><td>{GetDate(result.itm.exp)}</td>
                    </tr>
                    : null
                }
                </table>
            </Fragment>
            )
        }



        function GetDate(sec){
            let date_s = new Date(sec * 1000);
            var options = { year: 'numeric', month: 'long', day: 'numeric' };
            return(
                date_s.toLocaleString(langStr[LANG], options)
            )
        }

    function handleSearch(event){
        var searchQuery = event.target.value.toLowerCase();
            setQuery(event.target.value);
    };


    function GetSearch(filtr){
        const form = new FormData()
              form.append('lang', setup.lang);
              form.append('filtr', filtr);
            
      API.postFormData('site_sn_search.php', form)
      
        .then(data => {
         if(query === data.q) { setResult(data); }
            //setAllIs({loading:false, error:false});
            })
        .catch(error => {
            setAllIs({loading:true, error:error});
         });
      }
}